import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

import CenteredWrapper from "ui/CenteredWrapper";
import Heading from "ui/Heading";
import { FlexItem, HR } from "components/forms/Forms.styles";
import DiaryForm from "./DiaryForm";
import AccessDenied from "components/AccessDenied";
import { getCurrentDate } from "utils/dynDateUtils";

function CreateDiaryPage() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initDiary = {
    title: "",
    content: "",
    mood: "",
    weather: "",
    diaryDate: getCurrentDate(),
  };

  const createDiary = async (values) => {
    setIsSubmitting(true);
    api
      .post(`${API_BASE}/api/student-diary/create`, values)
      .then((res) => {
        if (res.status == 200) {
          const diaryId = res.data?.data;
          navigate(`/diary/${diaryId}`);
        }
      })
      .catch(() => alert("Failed to create a new diary."))
      .finally(() => setIsSubmitting(false));
  };

  if (!isAuthenticated) {
    return <AccessDenied />;
  }

  return (
    <CenteredWrapper
      display="flex"
      justifyContent="start"
      flexDirection="column"
      mt="80px"
      minHeight="calc(100vh - 180px)"
      maxWidth="900px"
    >
      <FlexItem>
        <Heading variant="h2">New Diary</Heading>
      </FlexItem>
      <HR className="light" />
      <DiaryForm
        data={initDiary}
        isDisabled={isSubmitting}
        updateDiary={createDiary}
      />
    </CenteredWrapper>
  );
}

export default CreateDiaryPage;
